var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"6","offset-lg":"3"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLSfu7LlLKXJIFUyagHHjAkwu3nqt_4ka0Wn61ZyZtlGcIBiuIw/viewform?embedded=true","width":"600","height":"1942","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Cargando…")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }